import * as Sentry from '@sentry/nextjs';

import { SuccessCreatedEntity, TagModel, TagType } from '@models';
import { APIRequestLabel } from '../consts';
import { callHttpDelete, callHttpGet, callHttpPatch, callHttpPost } from '../http';

const getTags = (get, set) => {
  return async () => {
    await callHttpGet(get, set, APIRequestLabel.GET_TAGS, `/tags`);

    let apiCallStatus = get().apiCallStatus[APIRequestLabel.GET_TAGS];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }

    set({
      tags: apiCallStatus.response?.tags
    });
  };
};

const createTag = (get, set) => {
  return async (tag): Promise<SuccessCreatedEntity> => {
    let payload = {
      text: tag.text
    };
    await callHttpPost(get, set, APIRequestLabel.CREATE_TAG, '/tags', payload);

    let apiCallStatus = get().apiCallStatus[APIRequestLabel.CREATE_TAG];
    if (apiCallStatus.error) {
      return Promise.reject(apiCallStatus.error);
    }

    let createdTag = {
      entityId: apiCallStatus.response.entityId,
      text: tag.text,
      type: TagType.USER_DEFINED
    };
    set({
      tags: [...get().tags, createdTag]
    });
    return apiCallStatus.response;
  };
};

const getTag = (get, set) => {
  return async (tagEntityId: string): Promise<TagModel> => {
    await callHttpGet(get, set, APIRequestLabel.GET_TAG, `/tags/${tagEntityId}`);

    let apiCallStatus = get().apiCallStatus[APIRequestLabel.GET_TAG];
    if (apiCallStatus.error) {
      return Promise.reject(apiCallStatus.error);
    }
    return apiCallStatus.response;
  };
};

const updateTag = (get, set) => {
  return async (tagEntityId: string, tag: TagModel) => {
    await callHttpPatch(get, set, APIRequestLabel.UPDATE_TAG, `/tags/${tagEntityId}`, {
      text: tag.text
    });

    let apiCallStatus = get().apiCallStatus[APIRequestLabel.UPDATE_TAG];
    if (apiCallStatus.error) {
      return Promise.reject(apiCallStatus.error);
    }

    let tags = get().tags;
    let tagIdx = tags.findIndex((t) => t.entityId === tagEntityId);
    if (tagIdx > -1) {
      tags[tagIdx] = { ...tag };
      set({
        tags: [...tags]
      });
    }
  };
};

const deleteTag = (get, set) => {
  return async (tagEntityId: string) => {
    await callHttpDelete(get, set, APIRequestLabel.DELETE_TAG, `/tags/${tagEntityId}`);

    let apiCallStatus = get().apiCallStatus[APIRequestLabel.DELETE_TAG];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }

    let tags = get().tags;
    let tagIdx = tags.findIndex((t) => t.entityId === tagEntityId);
    if (tagIdx > -1) {
      tags.splice(tagIdx, 1);
      set({
        tags: [...tags]
      });
    }
  };
};

export { createTag, deleteTag, getTag, getTags, updateTag };
